import { render, staticRenderFns } from "./invoiceRecord.vue?vue&type=template&id=3bb42349&scoped=true&"
import script from "./invoiceRecord.vue?vue&type=script&lang=js&"
export * from "./invoiceRecord.vue?vue&type=script&lang=js&"
import style0 from "./invoiceRecord.vue?vue&type=style&index=0&id=3bb42349&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb42349",
  null
  
)

export default component.exports